// Configuration des tentatives
const AUTH_CONFIG = {
    MAX_ATTEMPTS: {
      LEVEL1: 5,
      LEVEL2: 3,
      LEVEL3: 2,
    },
    LOCKOUT_TIME: {
      LEVEL1: 10 * 1000,  // 30 secondes
      LEVEL2: 60 * 1000,  // 1 minute
    }
  };
  
  // Gestion des tentatives échouées
  export const handleFailedAttempt = (formType) => {
    const storageKey = `auth_attempts_${formType}`;
    let attempts = JSON.parse(localStorage.getItem(storageKey) || '{"count": 0, "timestamp": 0, "level": 1, "totalFailures": 0}');
    
    // Incrémenter le compteur
    attempts.count += 1;
    attempts.totalFailures += 1;
    attempts.timestamp = Date.now();
    
    // Vérifier si le niveau doit changer
    if (attempts.level === 1 && attempts.count >= AUTH_CONFIG.MAX_ATTEMPTS.LEVEL1) {
      // Si niveau 1 et 5+ tentatives, activer le blocage
      attempts.blockUntil = Date.now() + AUTH_CONFIG.LOCKOUT_TIME.LEVEL1;
    } 
    else if (attempts.level === 2 && attempts.count >= AUTH_CONFIG.MAX_ATTEMPTS.LEVEL2) {
      // Si niveau 2 et 3+ tentatives, activer le blocage
      attempts.blockUntil = Date.now() + AUTH_CONFIG.LOCKOUT_TIME.LEVEL2;
    }
    else if (attempts.level === 3 && attempts.count >= AUTH_CONFIG.MAX_ATTEMPTS.LEVEL3) {
      // Si niveau 3 et 2+ tentatives, activer le reCAPTCHA
      attempts.requireCaptcha = true;
    }
    
    localStorage.setItem(storageKey, JSON.stringify(attempts));
    
    return attempts;
  };
  
  // Vérifier si le formulaire est bloqué
  export const isFormLocked = (formType) => {
    const storageKey = `auth_attempts_${formType}`;
    const attempts = JSON.parse(localStorage.getItem(storageKey) || '{"count": 0, "timestamp": 0, "level": 1, "totalFailures": 0}');
    
    const currentTime = Date.now();
    
    // Si le temps de blocage est dépassé, passer au niveau suivant et réinitialiser le compteur
    if (attempts.blockUntil && currentTime > attempts.blockUntil) {
      if (attempts.level === 1) {
        // Passer au niveau 2 après le premier blocage
        attempts.level = 2;
        attempts.count = 0;
        delete attempts.blockUntil;
        localStorage.setItem(storageKey, JSON.stringify(attempts));
      } 
      else if (attempts.level === 2) {
        // Passer au niveau 3 après le deuxième blocage
        attempts.level = 3;
        attempts.count = 0;
        delete attempts.blockUntil;
        localStorage.setItem(storageKey, JSON.stringify(attempts));
      }
    }
    
    // Vérifier si le reCAPTCHA est nécessaire
    if (attempts.requireCaptcha) {
      return { 
        locked: true, 
        requireCaptcha: true, 
        remainingTime: 0, 
        level: attempts.level,
        attemptCount: attempts.count,
        totalFailures: attempts.totalFailures
      };
    }
    
    // Vérifier si le formulaire est encore bloqué
    if (attempts.blockUntil && currentTime < attempts.blockUntil) {
      const remainingTime = attempts.blockUntil - currentTime;
      return {
        locked: true,
        remainingTime,
        level: attempts.level,
        attemptCount: attempts.count,
        totalFailures: attempts.totalFailures
      };
    }
    
    // Le formulaire n'est pas bloqué
    return { 
      locked: false, 
      remainingTime: 0, 
      level: attempts.level,
      attemptCount: attempts.count,
      totalFailures: attempts.totalFailures
    };
  };
  
  // Réinitialiser le compteur de tentatives
  export const resetAttempts = (formType) => {
    localStorage.removeItem(`auth_attempts_${formType}`);
  };
  
  // Réinitialiser uniquement le blocage CAPTCHA (après validation)
  export const resetCaptcha = (formType) => {
    const storageKey = `auth_attempts_${formType}`;
    const attempts = JSON.parse(localStorage.getItem(storageKey) || '{"count": 0, "timestamp": 0, "level": 1, "totalFailures": 0}');
    
    attempts.requireCaptcha = false;
    attempts.count = 0;  // Réinitialiser le compteur pour ce niveau
    
    localStorage.setItem(storageKey, JSON.stringify(attempts));
  };
  
  // Génère un jeton CSRF
  export const generateCSRFToken = () => {
    // Vérifier si un jeton existe déjà dans la session
    const existingToken = sessionStorage.getItem('csrf_token');
    if (existingToken) {
      return existingToken;
    }
    
    // Sinon, générer un nouveau jeton
    const token = Math.random().toString(36).substring(2, 15) + 
                 Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem('csrf_token', token);
    return token;
  };

  // Vérifie un jeton CSRF
  export const validateCSRFToken = (token) => {
    const storedToken = sessionStorage.getItem('csrf_token');
    return token === storedToken;
  };
  
  // Formater le temps restant en secondes ou minutes
  export const formatRemainingTime = (milliseconds) => {
    const seconds = Math.ceil(milliseconds / 1000);
    if (seconds < 60) {
      return `${seconds} seconde${seconds > 1 ? 's' : ''}`;
    }
    const minutes = Math.ceil(seconds / 60);
    return `${minutes} minute${minutes > 1 ? 's' : ''}`;
  };